<template>
  <v-list-item
    two-line
    :disabled="disableItem"
    @click="goToPendenciesList"
  >
    <app-item-avatar-pendencias
      :percentage="percentual"
    />
    <v-list-item-content>
      <v-list-item-title
        class="font-weight-medium"
        v-text="titulo"
      />
      <v-list-item-subtitle v-text="data.subtitle" />
    </v-list-item-content>
    <v-list-item-action>
      <v-icon color="grey lighten-1">
        arrow_forward_ios
      </v-icon>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import Store from '@/store'
import pluralize from '@/plugins/pluralize'
import AppItemAvatarPendencias from './AppItemAvatarPendencias'
import { mapGetters } from 'vuex'
export default {
  components: {
    AppItemAvatarPendencias
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters(['onlyTecnico']),
    disableItem () {
      return this.data.disabled || !this.data.route
    },
    titulo () {
      const parcial = Number(Store.getters.pendencias[this.data.entity].pendencias)
      return `${parcial} ${pluralize(this.data.singular, parcial)} ${pluralize(this.data.cause, parcial)}`
    },
    percentual () {
      const full = Number(Store.getters.pendencias[this.data.entity].total)
      const parcial = Number(Store.getters.pendencias[this.data.entity].pendencias)

      return 100 - ((parcial * 100) / full)
    }
  },
  methods: {
    goToPendenciesList () {
      if (this.onlyTecnico) {
        return this.$router.push({
          name: this.data.route,
          query: { fromTecnico: null }
        })
      }
      this.$router.push({
        name: this.data.route
      })
    }
  }
}
</script>
